import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';

const KnowledgeBaseHeader = ({
  companies,
  selectedClientId,
  isCompaniesLoading,
  onClientChange,
}) => (
  <>
    <Box
      display='flex'
      justifyContent='space-between'
      alignItems={{ xs: 'stretch', md: 'flex-start' }}
      flexDirection={{ xs: 'column', md: 'row' }}
      gap={2}
      mb={3}
    >
      <Box minWidth={0}>
        <Typography variant='h5' fontWeight={700} mb={0.75}>
          Knowledge Base
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ maxWidth: 640 }}>
          Browse and search the structured client knowledge created from source processing.
        </Typography>
      </Box>

      <FormControl size='small' sx={{ minWidth: { xs: '100%', md: 220 }, maxWidth: { md: 280 } }}>
        <InputLabel id='kb-client-label'>Client</InputLabel>
        <Select
          labelId='kb-client-label'
          label='Client'
          value={selectedClientId}
          onChange={onClientChange}
          disabled={isCompaniesLoading || companies.length === 0}
          inputProps={{ 'aria-label': 'Select client' }}
        >
          {companies.length === 0 ? (
            <MenuItem value=''>
              <em>Select client</em>
            </MenuItem>
          ) : (
            companies.map((company) => (
              <MenuItem key={company._id} value={company._id}>
                {company.companyName}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </Box>
  </>
);

export default KnowledgeBaseHeader;
